import React from 'react';
import { Crown, Mail, MessageSquare, Send } from 'lucide-react';
import { useMediaQuery, Box, Typography, Divider } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { CustomPaletteColor } from '../../theme';
import { FlexBetween } from '../FlexBetween';
import { SiteLogoProps } from './SiteLogo.types'; // Assuming you have a separate file for types
import { getSiteLogoAccentIconColor, getSiteLogoAccentTextColor, getSiteLogoChannelIconColors } from './siteLogoTheme';


export const MinifiedIUSiteLogo: React.FC<SiteLogoProps> = ({ varient }: SiteLogoProps) => {
    let isNonMobile = useMediaQuery('(min-width: 600px)');
    isNonMobile = varient === 'small' ? false : isNonMobile; // Override for small variant
    const theme = useTheme();
    const channelIcons = getSiteLogoChannelIconColors(theme);
    const accentIconColor = getSiteLogoAccentIconColor(theme);
    const accentTextColor = getSiteLogoAccentTextColor(theme, (theme.palette.primary as CustomPaletteColor)[200]);
    return (
        <Box
            sx={{
                padding: varient === 'small' ? '0.9rem' : '0rem',
            }}>
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: !isNonMobile ? 'center' : 'flex-start',
                    width: '100%',
                    marginTop: '-1.5rem',
                }}>

                {/* Logo Container */}
                <FlexBetween sx={{
                    gap: isNonMobile ? "9.2rem" : '1rem',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}>
                    {/* Crown Icon */}
                    <Box sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'left',
                        marginLeft: '0rem',
                        position: 'relative',
                        top: 15,
                        left: 35,
                        animation: 'bounceDiag 1s infinite',
                        '@keyframes bounceDiag': {
                            '0%, 100%': { transform: 'translate(0, 0)' },
                            '50%': { transform: 'translate(8px, -8px)' },
                        },
                    }}>
                        <Send strokeWidth={1.5} width={isNonMobile ? 30: 20} height={isNonMobile ? 50:40} color={accentIconColor} style={{ transform: 'rotate(0deg' }} />
                    </Box>
                </FlexBetween>
                <Box sx={{ 
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontFamily: 'Poppins, sans-serif' }}>
                    {/* Row of icons */}
                    <Box sx={{ display: 'flex', flexDirection: 'row', gap: 0.5, alignItems: 'center', mb: 0.5 }}>
                        <MessageSquare className="w-10 h-10 sm:w-12 sm:h-12 transform transition-transform duration-300 group-hover:scale-110" strokeWidth={2} color={channelIcons.message} />
                        <Mail className="w-10 h-10 sm:w-12 sm:h-12 transform transition-transform duration-300 group-hover:scale-110" strokeWidth={2} color={channelIcons.mail} />
                    </Box>
                    {/* Typography on next line */}
                    <Typography variant='h1' align='center' sx={{color: (theme.palette.secondary as CustomPaletteColor)[200], fontSize: isNonMobile ? '2.5rem' : '1.5rem', fontWeight: 'bold', textAlign: 'center' }}>
                        I.<span style={{ color: accentTextColor }}>Update</span>
                    </Typography>
                </Box>

            </Box>
        </Box>
    );
};
